import { render, staticRenderFns } from "./CreateTicketForm.vue?vue&type=template&id=46efde5c"
import script from "./CreateTicketForm.vue?vue&type=script&lang=js"
export * from "./CreateTicketForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports